import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class PackageService {
  readonly name = '@apexdesigner/photo-caliper';
  readonly version = '0.5.0';
  readonly description = '';
  readonly displayName = 'Photo Caliper';
}
